import { tv, type VariantProps } from 'tailwind-variants';

export const textVariants = tv({
  base: 'font-sans',
  variants: {
    as: {
      span: 'inline',
      div: 'block',
      label: 'inline',
      p: 'inline-block',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
    color: {
      'gray-dark': 'text-gray-500',
      gray: 'text-foreground/55',
      muted: 'text-muted',
      green: 'text-green-500',
      primary: 'text-primary-500',
      red: 'text-red-500',
    },
    muted: {
      true: 'text-muted',
    },
    error: {
      true: 'text-red-500',
    },
    weight: {
      bold: 'font-bold',
      semibold: 'font-semibold',
      medium: 'font-medium',
      light: 'font-light',
      thin: 'font-thin',
      normal: 'font-normal',
    },
    size: {
      inherit: 'text-[length:inherit]',
      xs: 'text-xs',
      sm: 'text-sm',
      base: 'text-base',
      lg: 'text-lg',
      xl: 'text-xl',
      '2xl': 'text-2xl',
      '3xl': 'text-3xl',
      '4xl': 'text-4xl',
      '5xl': 'text-5xl',
      '6xl': 'text-6xl',
      '7xl': 'text-7xl',
      '8xl': 'text-8xl',
      '9xl': 'text-9xl',
    },
    truncate: {
      true: 'truncate',
    },
    pretty: {
      true: 'text-pretty',
    },
    allCaps: {
      true: 'uppercase',
    },
    font: {
      monospace: 'font-mono',
    },
  },
  defaultVariants: {
    as: 'p',
    align: 'left',
    size: 'inherit',
  },
});

export interface TextProps extends VariantProps<typeof textVariants> {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export function Text({
  as = 'p',
  align,
  size,
  weight,
  muted,
  color,
  pretty,
  allCaps,
  font,
  truncate,
  error,
  children,
  className,
  ...props
}: TextProps): React.ReactElement {
  const Tag = as;

  return (
    <Tag
      className={textVariants({
        align,
        size,
        weight,
        muted,
        color,
        pretty,
        allCaps,
        truncate,
        font,
        error,
        className,
      })}
      {...props}
    >
      {children}
    </Tag>
  );
}
